// CTV-785: the campaign receipt, the list of finished AI commercials on a
// surface, joined to the creative slots that carry them right now.
//
// "Finished" comes from useAiCommercials (`finished`: ever in the campaign,
// or rendered; the active commercial excluded). "In the campaign" is the
// slot join done here, so a slot the buyer removed leaves its commercial on
// the receipt as "Not in your campaign" with an Add to campaign button,
// instead of making it the active commercial again.

import type { FinishedCommercial } from './useAiCommercials';
import type { ReceiptEntry } from './types';

export interface ReceiptSlotLike {
  slotId: string;
  storagePath?: string | null;
  filename?: string | null;
  waymarkCommercialId?: string | null;
}

/** A slot counts as carrying its commercial once it holds (or is uploading) a file. */
function carries(slot: ReceiptSlotLike): boolean {
  return !!slot.waymarkCommercialId && (!!slot.storagePath || !!slot.filename);
}

export function buildReceipt(
  finished: ReadonlyArray<FinishedCommercial>,
  slots: ReadonlyArray<ReceiptSlotLike>,
): ReceiptEntry[] {
  return finished.map((c) => {
    const slot = slots.find((s) => s.waymarkCommercialId === c.id && carries(s)) ?? null;
    return {
      commercialId: c.id,
      ordinal: c.ordinal,
      slotId: slot?.slotId ?? null,
      storagePath: slot?.storagePath ?? null,
      renderedUrl: c.renderedUrl,
      videoId: c.videoId,
      inCampaign: slot != null,
    };
  });
}
